import { atom } from "recoil";

export const examinationTypesState = atom({
  key: "examinationTypes",
  default: null,
});
